import ApiService from '@/utils/ApiService';
// import RestrictionUtils from '@/utils/client/RestrictionUtils';
// const {getRestrictions} = RestrictionUtils();
// MODULES
import quotas from "@/store/modules/client/modules/quotas";

export default {
	namespaced: true,
	modules: {
		quotas
	},
	state: {
		clientsURL: '/clients/',
		clientMapsURL: '/maps',
		featuresURL: '/features',
		settingsURL: '/settings',
		logoURL: '/logo',
		analyticsURL: '/analytics',
		analyticsReportsURL: '/analytics/reports',
		invoicesURL: '/subscription/invoices',
		manageSubscriptionURL: '/subscription/portal',
		testingPeriodURL: '/testing_period',
		usersAccessURL: '/users_map_access',
		externalContentURL: '/external_content',
		analyticsProvider: null,
		analyticsProviderFetched: false,
		features: null,
		restrictions: null,
		testingPeriodDetails: null,
		testingBuyURL: null,
	},
	getters: {
		getClientsURL(state){
			return state.clientsURL
		},
		getClientMapsURL(state){
			return state.clientMapsURL;
		},
		getClientFeaturesURL(state){
			return state.featuresURL;
		},
		getClientSettingsURL(state){
			return state.settingsURL
		},
		getClientLogoURL(state){
			return state.logoURL;
		},
		getClientAnalyticsURL(state){
			return state.analyticsURL;
		},
		getClientAnalyticsReportsURL(state){
			return state.analyticsReportsURL;
		},
		getInvoicesURL(state){
			return state.invoicesURL;
		},
		getManageSubscriptionURL(state){
			return state.manageSubscriptionURL;
		},
		getClientFeatures(state){
			return state.features;
		},
		getRestrictions(state){
			return state.restrictions;
		},
		getTestingPeriodDetails(state){
			return state.testingPeriodDetails;
		},
		getTestingPeriodURL(state){
			return state.testingPeriodURL;
		},
		getTestingBuyURL(state){
			return state.testingBuyURL;
		},
		getUsersAccessURL(state){
			return state.usersAccessURL;
		},
		getExternalContentURL(state){
			return state.externalContentURL;
		},
		getAnalyticsProvider(state){
			return state.analyticsProvider;
		},
		isAnalyticsProviderFetched(state){
			return state.analyticsProviderFetched;
		},
	},
	mutations: {
		SET_FEATURES(state, features){
			state.features = features;
		},
		UPDATE_FEATURES(state, features){
			Object.assign(state.features, features);
		},
		SET_RESTRICTIONS(state, restrictions){
			state.restrictions = restrictions;
		},
		SET_TESTING_DETAILS(state, testingDetails){
			state.testingPeriodDetails = testingDetails;
		},
		SET_TESTING_BUY_URL(state, url){
			state.testingBuyURL = url;
		},
		SET_ANALYTICS_PROVIDER(state, provider){
			state.analyticsProvider = provider;
			state.analyticsProviderFetched = true;
		},
		PUT_CLIENT_TO_STORAGE(state, client){
			state.clientFromStorage = client;
		}
	},
	actions: {
		featuresSet({commit}, features){
			commit('SET_FEATURES', features);
		},
		featuresUpdate({commit}, features){
			commit('UPDATE_FEATURES', features);
		},
		restrictionsSet({commit}, data){
			commit('SET_RESTRICTIONS', data /*getRestrictions(data)*/);
		},
		testingBuyURLSet({commit}, url){
			commit('SET_TESTING_BUY_URL', url);
		},
		async fetchTestingDetails({getters, commit, dispatch}, clientSlug){
			const clientsURL = getters.getClientsURL;
			const testingPeriodURL = getters.getTestingPeriodURL;
			try{
				const {data} = await ApiService.get(`${clientsURL}${clientSlug}${testingPeriodURL}`)
				commit('SET_TESTING_DETAILS', data);
				const {buy_urls, payment_interval} = data;
				const host = import.meta.env.VITE_ROOT_HOST;
				commit('SET_TESTING_BUY_URL', host + buy_urls[payment_interval])
			} catch(err){
				console.log(err);
			}
		},
		async fetchFeatures({getters, commit, dispatch}, clientSlug){
			const clientsURL = getters.getClientsURL;
			const featuresURL = getters.getClientFeaturesURL;
			try{
				const {data} = await ApiService.get(`${clientsURL}${clientSlug}${featuresURL}?expand=fonts`)
				commit('SET_FEATURES', data);
				dispatch('fonts/fontsFetchedSave', data.fonts, {root: true})

				// turn external content providers to boolean
				const result = JSON.parse(JSON.stringify(data));
				result.external_content_providers = result.external_content_providers.length && result.external_content_providers.some(source => source.enabled)
				return Promise.resolve(result);
			} catch(err){
				return Promise.reject(null);
			}
		},
		async fetchAnalyticsProvider({getters, commit, state}){
			if(state.analyticsProviderFetched) return;
			const clientsURL = getters.getClientsURL;
			const clientSlug = this.getters['user/getClientName'];
			const analyticsURL = getters.getClientAnalyticsURL;
			try{
				const {data} = await ApiService.get(`${clientsURL}${clientSlug}${analyticsURL}`);
				commit('SET_ANALYTICS_PROVIDER', data.analytics_provider);
			} catch(err){
				console.log(err);
			}
		},
		async fetchExternalFeatures({getters, commit, dispatch}, clientSlug) {
			const clientsURL = getters.getClientsURL;
			const externalContentURL = getters.getExternalContentURL;

			try{
				const {data: {providers}} = await ApiService.get(`${clientsURL}${clientSlug}${externalContentURL}`)
				// save providers to external content store

				dispatch('externalContent/contentProvidersSet', providers, {root: true});
				return Promise.resolve(providers);
			} catch(err){
				return Promise.reject(null);
			}
		}
	}
}
